'use client';

import { useMemo } from 'react';

import {
  CategoryDesktopLayoutTemplate,
  CategoryMobileLayoutTemplate
} from 'components/atomic/template';
import { DEVICE_SURFACE } from 'config/common';
import { GetUiDeviceSurface } from 'helpers/screenResolutionHelper';
import { getPageURL, ROUTE_CONFIG } from 'services/hostPortal.service';

const ParentCategoryClient = ({
  categories,
  category,
  categorySeoDetails,
  initialProducts,
  parentCategories,
  parentCategoryName,
  parentSlug,
  priceRange,
  productsCount
}) => {
  const surface = GetUiDeviceSurface();

  const breadcrumbsInfo = useMemo(
    () => [
      {
        link: getPageURL({ pageName: ROUTE_CONFIG.HOME_PAGE.label }),
        name: 'Home'
      },
      { link: '', name: parentCategoryName }
    ],
    [parentCategoryName]
  );

  // Map the layout based on detected device surface
  const categoryLayoutMap = {
    [DEVICE_SURFACE.MOBILE]: CategoryMobileLayoutTemplate,
    [DEVICE_SURFACE.WEB]: CategoryDesktopLayoutTemplate
  };

  const CategoryLayout = categoryLayoutMap[surface];

  return (
    <CategoryLayout
      {...{
        breadcrumbsInfo,
        categories,
        category,
        categorySeoDetails,
        initialProducts,
        parentCategories,
        parentCategoryName,
        parentSlug,
        priceRange,
        productsCount
      }}
    />
  );
};

export default ParentCategoryClient;
